var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercuryMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 20,
    viewBox: "0 0 44 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6067 0C39.8001 0 42.209 3.12513 43.43 5.27876C43.7057 5.76502 43.3363 6.36644 42.7867 6.46865C38.4817 7.26937 35.4237 12.1882 34.1123 15.6469C32.6292 19.5586 20.7641 19.5586 18.7865 18.5807C16.809 17.6028 16.3146 11.2462 19.7753 6.84553C23.236 2.44483 28.4439 0 34.6067 0Z",
    fill: "#0065A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.42276H25.2079C25.484 3.42276 25.7079 3.64662 25.7079 3.92276V4.87863C25.7079 5.15477 25.484 5.37863 25.2079 5.37863H1.97753L0 3.42276Z",
    fill: "#F36F2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95506 7.33447H26.1966C26.4728 7.33447 26.6966 7.55833 26.6966 7.83447V8.79034C26.6966 9.06648 26.4728 9.29034 26.1966 9.29034H5.70441L3.95506 7.33447Z",
    fill: "#F36F2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91011 11.2463H28.1741C28.4503 11.2463 28.6741 11.4702 28.6741 11.7463V12.7022C28.6741 12.9783 28.4503 13.2022 28.1741 13.2022H9.50734L7.91011 11.2463Z",
    fill: "#F36F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercuryMb);
export default __webpack_public_path__ + "static/media/mercury-mb.265def7fe655f69e09668adf33892221.svg";
export { ForwardRef as ReactComponent };